/**
 * HTTP layer for the command-queue status. A snapshot of the outbound command
 * queue depth and health (`/queuestatus/`).
 *
 * Contains:
 * - fetchQueueStatus: current queue status
 */
import apiClient from '@sophocles/http-common';
import { checkHttpStatus } from '@sophocles/utils';

export const fetchQueueStatus = () =>
  apiClient
    .get('/queuestatus/')
    .then(checkHttpStatus)
    .then(res => res.data);
